import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import useStyles from 'hooks/useStyles';
import ContextStore from 'utils/createContext';

import { getLiveTopic } from 'reduxModules/live/selector';

import ScheduleItem from '../ScheduleItem';

import styles from './Schedule.scss';

function Schedule() {
  useStyles(styles);
  const { t } = useTranslation(['live', 'rating']);
  const {
    scheduledLessons: { allLiveLessons },
  } = useSelector(getLiveTopic);

  const { liveTopicId, liveTopicName } = useContext(ContextStore);

  return (
    <div className={styles.root}>
      <h1 className={styles.title}>{t('topic.overview.detail.upcoming')}</h1>
      <div className={styles.list}>
        {allLiveLessons.map(({ id, name, time }) => (
          <ScheduleItem
            key={id}
            name={name}
            time={time}
            t={t}
            topicId={liveTopicId}
            topicName={liveTopicName}
          />
        ))}
      </div>
    </div>
  );
}

export default Schedule;
